// Setting the base path for all assets.
// https://webpack.js.org/guides/public-path/#on-the-fly
// this makes sure that client side uses the cdn path

// eslint-disable-next-line no-undef
__webpack_public_path__ = window.__PUBLIC_ASSET_PATH__;
